<template>
    <div id="echart-pie" :style="{ height: '100%',width:'100%'}"></div>   
</template>

<script>
export default({
    data(){
        return{
            pieName:[],
            pieData:[],
            pieTitle:"",
        }
    },
    methods: {
        initData(pieData,pieTitle) {
            this.pieData = pieData;
            this.pieTitle = pieTitle;
            for (let i = 0; i < this.pieData.length; i++) {
                this.pieName[i] = this.pieData[i].name;
            }
        },
        initChart() {  
            this.pieChart = this.echarts.init(document.getElementById("echart-pie"));
            const option = {
                legend: { 
                    data: this.pieName,
                    orient: 'vertical',
                    right: 5,
                    top: 'center'
                },
                title: { 
                    text: this.pieTitle,
                    top: "0%",
                    left: "center",
                    textStyle: {
                        "fontSize": 15
                    }
                },
                grid:{
                    left:0
                },
                series: [{
                    type: "pie",
                    label: {
                        show: true,
                        formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg =
                                str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return str.replace(reg, "$1,");
                        },
                    },
                    itemStyle: {
                        normal: {
                            // color: function (params) {
                            //     // build a color map as your need.
                            //     var colorList = [
                            //         'rgb(238,102,104)','rgb(165,218,84)','rgb(251,241,123)','rgb(130,204,232)',
                            //     ];
                            //     return colorList[params.dataIndex]
                            // },
                        }
                    },
                    center:['45%', '53%'],
                    radius: "44%", 
                    data: this.pieData
                }],
                tooltip: {
                    trigger: 'item',
                    formatter:function(p){
                            if (!p.value && p.value !== 0) return 0;
                            let str = p.value.toString();
                            let reg = str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
                            return p.name+" : "+str.replace(reg, "$1,")+" ("+p.percent+"%)";
                        },
                    position: ['50%', '50%']
                },
            };
            this.pieChart.setOption(option);
            //随着屏幕大小调节图表
            window.addEventListener("resize", () => {
                this.pieChart.resize();
            });
        }
    }
})
</script>
